//* Third Party Libraries
import { useState } from "react";

//* Local or Custom Libraries
import { Button } from "@lululemon/ui-library";
import { searchIcon } from "@lululemon/ui-icons";
import { USER_COUNTRY } from "../utilities/constants";

//* Importing Styles
import styles from "../bopis-modal.module.scss";

/**
 * @param {function} getAddressFromSearchQuery - a function to get the address from the user's search query.
 * @param {object} getUserAddressError - an error set from the getCurrentPosition or geocodeCoordinates if no location could be found.
 * @param {function} handleGetUserAddress - a function to get the user's exact address using geolocation.
 * @param {function} setUserSearchedLocation - a function to set the user's searched location.
 * @param {function} setGetUserAddressError - a function to set the error when fetching the user address.
 * @param {object} userLocation - an object that contains data of user location
 * @param {string} userCountry - "US" or "CA"
 */
const BopisModalSearch = ({
  getAddressFromSearchQuery,
  getUserAddressError,
  handleGetUserAddress,
  setUserSearchedLocation,
  setGetUserAddressError,
  userLocation,
  userCountry
}) => {
  const [userSearchQueryInput, setUserSearchQueryInput] = useState("");

  const searchPlaceholder =
    userCountry === USER_COUNTRY.US
      ? "Enter your Zip Code or City/State"
      : "Enter your Postal Code or City/Province";

  const handleChange = (value) => {
    setUserSearchQueryInput(value);
    if (value === "" && (userLocation.city || userLocation.address)) {
      setUserSearchedLocation({
        address: userLocation.address,
        lat: userLocation.lat,
        lng: userLocation.lng,
        city: userLocation.city,
        state: userLocation.state
      });
    }
  };

  const handleSearch = async () => {
    if (!userSearchQueryInput.trim()) return;

    try {
      const geocodeAddressFromSearch = await getAddressFromSearchQuery(
        userSearchQueryInput
      );

      if (getUserAddressError) {
        setGetUserAddressError(null);
      }

      if (geocodeAddressFromSearch?.address) {
        setUserSearchedLocation({
          address: geocodeAddressFromSearch.address,
          lat: geocodeAddressFromSearch.lat,
          lng: geocodeAddressFromSearch.lng,
          city: null,
          state: null
        });
      }
    } catch (error) {
      console.error("Error fetching Address from SearchQuery:", error);
    }
  };

  return (
    <div>
      <h2>Store Pickup Availability</h2>
      <div className={styles.searchAndLocationContainer}>
        <div className={styles.searchBarContainer}>
          <input
            className={styles.searchBar}
            type="text"
            aria-label="Search"
            placeholder={searchPlaceholder}
            value={userSearchQueryInput}
            onChange={(e) => handleChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
          />
          <Button
            className={styles.searchBarIcon}
            icon={searchIcon}
            type="submit"
            onClick={handleSearch}
          />
        </div>
        <div className={styles.locationButtonContainer}>
          or{" "}
          <button
            className={styles.locationButton}
            onClick={() => {
              setUserSearchQueryInput("");
              handleGetUserAddress();
            }}
          >
            Use My Current Location
          </button>
        </div>
      </div>
    </div>
  );
};

export default BopisModalSearch;
